import { render, staticRenderFns } from "./DefaultDataHeader.vue?vue&type=template&id=09d0e506&scoped=true&"
import script from "./DefaultDataHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultDataHeader.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDataHeader.vue?vue&type=style&index=0&id=09d0e506&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0e506",
  null
  
)

export default component.exports